<script setup lang="ts">
import AccordionHeader, {
  type AccordionHeaderProps
} from "primevue/accordionheader";

export interface TaiAccordionHeaderProps extends AccordionHeaderProps {}

defineProps<TaiAccordionHeaderProps>();
</script>

<template>
  <AccordionHeader v-bind="{ ...$props, ...$attrs }">
    <slot></slot>
  </AccordionHeader>
</template>
